<div class="d-flex flex-wrap align-items-center justify-content-between mb-5 mt-7">
  <base-search
    placeholder="search.general"
    [value]="activatedRoute.snapshot.queryParams.search"
    [useEnterEvent]="true"
    (query)="onSearchChange($event)"
  ></base-search>
  <div class="mt-2 mt-sm-0">
    <base-action-dropdown
      *ngIf="!isWorkCouncil"
      label="action.export"
      color="dark"
      [items]="['workingContracts', 'administration.operationalInformation']"
      (listItemClicked)="handleClick($event)"
    ></base-action-dropdown>
  </div>
</div>
